import { Skeleton } from '@sib/ui';

const DEFAULT_FIELD_SKELETON_COUNT = 10;

interface DetailsSkeletonProps {
  fieldCount?: number;
}

export const DetailsSkeleton = ({
  fieldCount = DEFAULT_FIELD_SKELETON_COUNT,
}: DetailsSkeletonProps) => (
  <div className="flex w-full flex-col">
    <div className="border-border flex flex-col gap-1 border-b pb-3">
      <Skeleton className="h-4 w-16" />
      <Skeleton className="h-5 w-3/4" />
    </div>
    <div className="border-border flex flex-col gap-1 border-b py-3">
      <Skeleton className="h-4 w-24" />
      <Skeleton className="h-5 w-full" />
      <Skeleton className="h-5 w-2/3" />
    </div>
    <div className="grid w-full grid-cols-1 sm:grid-cols-2 sm:gap-x-8">
      {Array.from({ length: fieldCount }).map((_, index) => (
        <div
          key={`details-skeleton-${index}`}
          className="border-border flex flex-col gap-1 border-b py-3"
        >
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-5 w-32" />
        </div>
      ))}
    </div>
  </div>
);
